import React, { useEffect, useState } from 'react'
import Header from '../Component/Header'
import Sidebar from '../Component/Sidebar'
import axios from 'axios'
import baseUrl from '../Constant'
import { Link } from 'react-router-dom'

function CaseList() {
    const [squery, setQuery] = useState()
    const [allCase, setAllCase] = useState([])
    const [message, setMessage] = useState()
    const [color, setColor] = useState()

    const caseData = (() => {
        const token = JSON.parse(localStorage.getItem('token'))
        console.log(token)
        axios.get(`${baseUrl}/accounts/case-list`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data.cases)
                setAllCase(res.data.cases)
            })
            .catch((error) => {
                console.log(error)
            })
    })

    const handleSearch = () => {
        const query = squery;
        const token = JSON.parse(localStorage.getItem('token'))
        console.log(query)
        axios.get(`${baseUrl}/accounts/case-list?case=${query}`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setAllCase(res.data.cases)
                if (res.data.status === 200) {
                    if (res.data.cases.length === 0) {
                        setColor("#ff0000");
                        setMessage('No Record Found !')
                        setTimeout(() => {
                            setMessage('')
                            setColor('')
                            caseData()
                        }, 3000)
                    }
                    else {
                        setMessage('')
                    }
                }
                else {
                    setColor("#ff0000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 3000)
                    console.log('red')
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    useEffect(() => {
        caseData()
    }, [])

    return (
        <div>
            <Header />
            <div className='d-flex'>
                <div>
                    <Sidebar />
                </div>
                <div className='container-fluid' style={{ backgroundColor: 'rgb(42 127 155 / 24%)' }}>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='p-3' style={{ textAlign: "center" }}>
                                <input type="text" placeholder='Search By Case' value={squery} style={{ padding: "10px", borderRadius: '8px', width: "30%" }} onChange={(e) => setQuery(e.target.value)} />
                                <button type='submit' className='btn btn-info ms-3 text-white fw-medium' onClick={handleSearch}>
                                    Search
                                </button>
                            </div>
                            <div className='row p-4'>
                                {
                                    message && <div style={{ marginBottom: 10, }}>
                                        <div style={{ fontSize: 20, fontWeight: 600, color: 'red', textAlign: "center", paddingHorizontal: 20, }}>{message}</div>
                                    </div>
                                }
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='active-member'>
                                            <div className='table-responsive'>
                                                <table className='table table-xs'>
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Patient Name</th>
                                                            <th>Case</th>
                                                            <th>Prescription</th>
                                                            <th>Date</th>
                                                            <th>Action</th>

                                                        </tr>
                                                    </thead>
                                                    {allCase &&
                                                        allCase.map((item, index) => {
                                                            console.log(item.patient)
                                                            return (
                                                                <tbody key={allCase.uid}>
                                                                    <tr>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.patient}</td>
                                                                        <td>{item.cases}</td>
                                                                        <td>{item.priscrption}</td>
                                                                        <td>{item.updated_at}</td>
                                                                        <td>
                                                                            <Link to={`/add-file/${item.uid}`}>
                                                                                <button className='btn btn-info text-white'>
                                                                                    View File
                                                                                </button>
                                                                            </Link></td>
                                                                    </tr>
                                                                </tbody>
                                                            )
                                                        })
                                                    }

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaseList